import * as React from 'react';
import { EUserCardTab } from './types';
import { UserCardImagesContainer } from '../../../containers/UserCardImagesContainer';
import { UserCardAboutTab } from '../UserCardAboutTab';

interface IProps {
  activeTab: EUserCardTab;
}

const CONTENT_MAP = {
  [EUserCardTab.About]: UserCardAboutTab,
  [EUserCardTab.Photos]: UserCardImagesContainer,
};

export const UserCardSwitcherContent = (props: IProps) => {
  const { activeTab } = props;

  const Component = CONTENT_MAP[activeTab];

  return <Component />;
};
